import Tools from './../components/tools';

export default class Faq {
  constructor() {
    // Archive Faq
    this.manageSubCategories();
    this.manageAccordions();
  }

  manageSubCategories() {
    const subCategories = document.querySelectorAll('section.content .categorie-wrapper .sous-categories li');
    if (subCategories.length > 0) {
      subCategories.forEach((category) => {
        category.addEventListener('click', () => {
          if (document.querySelector('section.content .categorie-wrapper .sous-categories li.active')) {
            document.querySelector('section.content .categorie-wrapper .sous-categories li.active').classList.remove('active');
          }
          category.classList.add('active');
          document.querySelector('section.content .categorie-wrapper .questions.active').classList.remove('active');
          document.querySelector(`section.content .categorie-wrapper .questions[data-tab="${category.dataset.id}"]`).classList.add('active');
        });
      });
    }
  }

  manageAccordions() {
    const accordions = document.querySelectorAll('section.content .categorie-wrapper .questions .onglet');
    if (accordions.length > 0) {
      accordions.forEach((accordion) => {
        accordion.querySelector('h3').addEventListener('click', () => {
          accordion.classList.toggle('open');

          if (accordion.classList.contains('open')) {
            Tools.zeroToAuto(accordion.querySelector('.onglet-container'));
          } else {
            Tools.autoToZero(accordion.querySelector('.onglet-container'));
          }
        });
      });
    }
  }
}